import { render, staticRenderFns } from "./DataQualityChip.vue?vue&type=template&id=eefcd2e6&lang=pug"
import script from "./DataQualityChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataQualityChip.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports